













import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },

    data: function() {
        return {
            uniqueId: uuidv4(),
            checkboxes: [
                {
                    value: "agree",
                    label: "terms_and_conditions_read_with_link"
                },
            ],
        };
    },

    computed: {
        ...mapState("AgreementModule", ["termsAndConditions"]),

        valueChecked: function(): Array<string> | void {
            if(this.termsAndConditions) {
                return ["agree"];
            }
        },
    },

    created: function() {
        this.$store.commit("AgreementModule/termsAndConditions", false);
    },


    methods: {
        updateValue: function(selectedValues: Array<string>): void {
            const isAgreementChecked = !!selectedValues.find(entry => entry === "agree");
            this.$store.commit("AgreementModule/termsAndConditions", isAgreementChecked);
        }
    },
});

